import React from 'react';
import { AwardIcon, CheckCircleIcon, UserCheckIcon } from 'lucide-react';
const About = () => {
  return <section id="about" className="py-16" data-id="element-11">
      <div className="container mx-auto px-4" data-id="element-12">
        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-13">
          <div data-id="element-14">
            <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-15">
              About Our EICR Services
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-16">
              At SafeCircuit EICR, we are dedicated to ensuring electrical
              safety in properties across the UK. Our team of qualified
              electricians specializes in conducting thorough Electrical
              Installation Condition Reports to keep your property compliant
              with the latest regulations.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-17">
              With over 15 years of industry experience, we've helped thousands
              of landlords, homeowners, and businesses maintain safe electrical
              installations and meet their legal obligations.
            </p>
            <div className="space-y-4" data-id="element-18">
              <div className="flex items-start" data-id="element-19">
                <AwardIcon className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0" data-id="element-20" />
                <div data-id="element-21">
                  <h3 className="font-semibold text-gray-800" data-id="element-22">
                    Qualified & Certified
                  </h3>
                  <p className="text-gray-600" data-id="element-23">
                    All our electricians are fully qualified and registered with
                    NICEIC.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-24">
                <CheckCircleIcon className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0" data-id="element-25" />
                <div data-id="element-26">
                  <h3 className="font-semibold text-gray-800" data-id="element-27">
                    Fast Turnaround
                  </h3>
                  <p className="text-gray-600" data-id="element-28">
                    Same-day certificates available for urgent requirements.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-29">
                <UserCheckIcon className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0" data-id="element-30" />
                <div data-id="element-31">
                  <h3 className="font-semibold text-gray-800" data-id="element-32">
                    Customer Satisfaction
                  </h3>
                  <p className="text-gray-600" data-id="element-33">
                    We pride ourselves on our 5-star customer service and
                    support.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-100 p-8 rounded-lg" data-id="element-34">
            <h3 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-35">
              What is an EICR?
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-36">
              An Electrical Installation Condition Report (EICR) is a formal
              document that assesses the safety of the existing electrical
              installations within a property. It identifies any damage,
              deterioration, defects, or dangerous conditions.
            </p>
            <div className="space-y-4" data-id="element-37">
              <div className="bg-white p-4 rounded-md border-l-4 border-blue-600" data-id="element-38">
                <h4 className="font-semibold text-gray-800" data-id="element-39">
                  Legal Requirements
                </h4>
                <p className="text-gray-600" data-id="element-40">
                  As of June 2020, landlords in England must have the electrical
                  installations in their rental properties inspected and tested
                  by a qualified person every 5 years.
                </p>
              </div>
              <div className="bg-white p-4 rounded-md border-l-4 border-yellow-500" data-id="element-41">
                <h4 className="font-semibold text-gray-800" data-id="element-42">
                  Safety Classifications
                </h4>
                <p className="text-gray-600" data-id="element-43">
                  EICR reports classify issues as C1 (danger present), C2
                  (potentially dangerous), or C3 (improvement recommended).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default About;